import { useRef } from 'react'

type Props = {
  elementId: string
}

export const useRecaptchaSitekey = ({ elementId }: Props) => {
  const containerRef = useRef(document.getElementById(elementId))
  return containerRef.current?.getAttribute('data-sitekey') ?? 'recaptchaPublicKey'
}
